import { StateToken } from '@ngxs/store';
import type { SessionStateModel } from './session-state.model';

export const SESSION_STATE_TOKEN = new StateToken<SessionStateModel>('session');
